import type { IconData } from '@stacksjs/iconify-core'

export const devicesVideoGames: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 5a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a5 5 0 0 1-4.9-4H4.9A5 5 0 0 1 0 15zm13.252 1a1.251 1.251 0 1 1-2.503 0a1.251 1.251 0 0 1 2.502 0M4 7.251A1.251 1.251 0 1 0 4 4.75a1.251 1.251 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesVideoGames
